const store = {};
const mutations = {
   
};
const state = {
    toolBarItems: [
        { name: "undo" } ,
        { name: "redo" },
        { name: "separator" },
        { name: "bold" },
        { name: "italic" },
        { name: "strike" },
        { name: "underline" },
        { name: "separator" },
        { name: "alignLeft" },
        { name: "alignCenter" },
        { name: "alignRight" },
        { name: "alignJustify" },
        { name: "separator" },
        { name: "color" },
        { name: "background" },
        { name: "variable" },
        { name: "link" },
    ],
};
const getters = {};
const actions = {
    
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}